module.exports = __webpack_public_path__ + "static/img/6.f2e1bfc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/sp/6.png
// module id = hIB2
// module chunks = 0